export const accountTypes = {
  ACCOUNT_LOGIN_ONCHANGE: "ACCOUNT_LOGIN_ONCHANGE",
};
